import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';

import { TokenStorageService } from '../../services/storage/token-storage.service';
import { KeycloakService } from 'keycloak-angular';
import { LoginService } from '../../services/login.service';

const AMERICAS_DISCLAIMER =
  'GTN technology infrastructure, including the Developer Portal, is provided through GTN Market Data Services Ltd, a company registered in the United Kingdom (registration number: 13863834). Such technology services are provided independently of any brokerage or financial services arrangement.';

@Component({
    selector: 'app-landing-product-page',
    templateUrl: './landing-product-page.component.html',
    styleUrls: ['./landing-product-page.component.css'],
    standalone: false
})
export class LandingProductPageComponent implements OnInit {
  @Input() selectedApi: string = '';
  @Input() showOpen: boolean = false;
  @Input() showFix: boolean = false;
  @Input() showBackOffice: boolean = false;

  show = false;
  showTrade = false;
  isLoggedIn: boolean;

  constructor(
    private tokenStorageService: TokenStorageService,
    private keycloakService: KeycloakService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private loginService: LoginService
  ) {
    this.show = !!this.tokenStorageService.getToken();
    this.showTrade = this.tokenStorageService.getUserType() == 'OMS';
    this.isLoggedIn = this.keycloakService.isLoggedIn();
  }

  ngOnInit(): void {
    this.showAmericasDisclaimerIfNeeded();
  }

  async login(redirectUrl: string) {
    if (this.isLoggedIn) {
      window.location.href = redirectUrl;
    } else {
      await this.loginService.login(redirectUrl);
    }
  }

  private showAmericasDisclaimerIfNeeded(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
      const region = params.get('region')?.toLowerCase();

      if (region !== 'americas' || this.isRegisteredUser()) {
        return;
      }

      this.toastr.show(AMERICAS_DISCLAIMER, '', {
        closeButton: true,
        extendedTimeOut: 0,
        positionClass: 'toast-bottom-full-width',
        tapToDismiss: false,
        timeOut: 5000,
        toastClass: 'ngx-toastr americas-disclaimer-toast',
      });
    });
  }

  private isRegisteredUser(): boolean {
    return this.isLoggedIn || !!this.tokenStorageService.getToken() || this.hasRegisteredUserCookie();
  }

  private hasRegisteredUserCookie(): boolean {
    const registeredUserCookieNames = [
      'auth-token',
      'refresh-token',
      'user',
      'user-type',
      'KEYCLOAK_SESSION',
      'KEYCLOAK_IDENTITY',
      'KEYCLOAK_REMEMBER_ME',
      'portal_registered_user',
      'registered_user',
    ];

    return document.cookie
      .split(';')
      .map((cookie) => cookie.trim().split('=')[0])
      .some((cookieName) => registeredUserCookieNames.includes(cookieName));
  }
}
